export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20floating%20in%20dark%20space%20displaying%20a%20cinematic%20movie%20streaming%20interface%20with%20film%20posters%20and%20play%20buttons%2C%20warm%20golden%20and%20deep%20red%20accents%2C%20glowing%20screen%20light%2C%20elegant%20minimalist%20design%2C%20dark%20background%20with%20soft%20bokeh%20effect%2C%20clean%20tech%20aesthetic%2C%20no%20text%20no%20logos&width=480&height=480&seq=app-qr-movie-2026&orientation=squarish"
              alt="6080影视移动端观影体验"
              className="w-full h-full object-cover"
              onError={(e) => {
                const target = e.currentTarget;
                target.style.display = 'none';
                target.parentElement!.classList.add('hidden');
              }}
            />
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              随时随地 · 移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              6080影视全面适配手机、平板等移动设备，高清画质自适应屏幕尺寸，
              不缓冲流畅播放。无论你在通勤路上还是旅行途中，打开手机浏览器即可享受海量免费高清电影。
            </p>
            <div className="flex items-center justify-center md:justify-start gap-3 text-xs md:text-sm text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-smartphone-line"></i> 手机浏览器访问
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-tablet-line"></i> 平板大屏观影
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-wifi-line"></i> 无需下载APP
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}